<script lang="ts" setup>
import ChatMessageItem from "@/components/mobile/ChatMessageItem.vue";
import ThreadList from "@/components/mobile/ThreadList.vue";
import { useGlobalUser } from "@/stores/globalUser";
import { computed, onMounted } from "vue";
import { useHouseMessageList } from "../composable/useHouseMessageList";
import { useHouseSession } from "../store/houseSession";

const props = withDefaults(
  defineProps<{
    isPostingMsg: "start" | "end" | false;
    showAvatar?: boolean;
    mateId?: number;
    hideNewest?: boolean;
  }>(),
  {
    showAvatar: true,
    hideNewest: false,
  }
);

const user = useGlobalUser();
const houseSessionStore = useHouseSession();
// Element Ref

const { messageList, scrollLoad, pullLoad } = useHouseMessageList({
  mateId: props.mateId,
});

const displayMessageList = computed(() => {
  let list = messageList.value;
  if (props.hideNewest) {
    // 删除第一个，返回剩下的
    list = list?.slice(1) ?? [];
  }
  if (houseSessionStore.subjectUpdateTime) {
    list =
      list?.filter(
        (item) =>
          new Date(item.dtCreate).getTime() >
          houseSessionStore.subjectUpdateTime!
      ) ?? [];
  }
  return list;
});

onMounted(async () => {
  await houseSessionStore.getOrFetchHouseSession(
    user.user.currentMateHouseSession.uuid
  );
  if (props.mateId) {
    await houseSessionStore.getOrFetchMateMessageList(props.mateId, true);
  } else {
    await houseSessionStore.initFullListIfAbsent();
  }
});
</script>

<template>
  <ThreadList
    :onScrollLoad="scrollLoad"
    :onPullLoad="pullLoad"
    enable-scroll-record
    :show-bottom-tip="displayMessageList.length > 0"
  >
    <slot name="header"></slot>
    <chat-message-item
      v-for="item in displayMessageList"
      :id="item.id"
      :key="item.id"
      ref="chatMessageRefs"
      :avatar-url="item.mate.mediaUrl"
      :enable-avatar-url="showAvatar"
      :enable-reactive="false"
      :mate-uuid="item.mate.uuid"
      :msg="item.content"
      :position="'start'"
      :time="item.dtCreate"
      size="xs"
    />
    <!-- StreamMsg返回前的loading -->
    <chat-message-item
      v-show="isPostingMsg"
      :enable-avatar-url="false"
      :position="isPostingMsg === 'start' ? 'start' : 'end'"
      :enable-audio="false"
      size="xs"
    >
      <div class="flex items-center">
        <span class="loading loading-dots loading-sm text-base-content" />
      </div>
    </chat-message-item>
  </ThreadList>
</template>
